import { createClient } from "@supabase/supabase-js";

export const DB = createClient(
  "https://gmcdxrwibvsetnsqlnbi.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdtY2R4cndpYnZzZXRuc3FsbmJpIiwicm9sZSI6ImFub24iLCJpYXQiOjE2OTkyNjM3ODIsImV4cCI6MjAxNDgzOTc4Mn0.Efrt1Ad2poHDAXR6pEz-A8ml9GJL4-dOUum2UPP664E"
);

export const getMaterialsData = async () => {
  const res = await DB.from("Materials_Data").select();
  if (res?.data?.length > 0 && res?.status === 200) {
    return res.data.filter(a => a.visible);
  }
  return [];
};


export const getProductsData = async () => {
  const res = await DB.from("Scene_Data").select();
  if (res?.data?.length > 0 && res?.status === 200) {
    return res.data;
  }
  return [];
};
